import axios from 'axios';
import router from '../router';
import vm from '../main';

axios.interceptors.request.use(
    function (config) {
        if (vm.$route.meta.showInCrumb) config.headers.token = sessionStorage.getItem('token');
        return config;
    }
)

axios.interceptors.response.use(
    function (res) {
        if (res.data.data == 'BAD_TOKEN') {
            sessionStorage.removeItem('token');
            router.push({ path: '/managerAuth', query: { nextUrl: vm.$route.path } });
        }
        return res;
    }
)

axios.defaults.withCredentials = true;

export default axios;


// WEBPACK FOOTER //
// ./src/axios/index.js